import { memo } from 'react';
import snakeCase from 'lodash.snakecase';

import { extractParamsFromMediaUrl } from '../../lib/mediaApiUrl';

import type { Wws_PhotoItem } from '../../types/graphql';
import DynamicNextImage from '../NextImage/DynamicNextImage';
import PhotoItemWrapper from './SharedComponents/PhotoItemWrapper';

export interface PhotoItemProps {
  item: Wws_PhotoItem;
  className?: string | undefined;
}

function PhotoItem({ item, className }: PhotoItemProps) {
  const aspectRatioName = item.aspectRatio?.name || '';

  const landscape = ['4:3', '3:2'].includes(aspectRatioName);

  const { crop, url } = extractParamsFromMediaUrl(item.mediaUrl);

  const alt = item.caption || 'photo';
  const photoRotation = item.rotation || 0;

  let photoCrop = crop;
  if (
    item.height !== 0 &&
    item.width !== 0 &&
    item.cropX !== undefined &&
    item.cropY !== undefined
  ) {
    const cropX = item.cropX || 0;
    const cropY = item.cropY || 0;
    const composedCrop = `${cropX}.${cropY}.${cropX + item.width}.${cropY + item.height}`;
    photoCrop = composedCrop;
  }

  return (
    <PhotoItemWrapper
      className={className}
      landscape={landscape}
      dataTestId={`${snakeCase(item.type).replace(/_/g, '-')}-${item.id}`}
    >
      <DynamicNextImage
        src={url || ''}
        crop={photoCrop}
        alt={alt}
        rotation={photoRotation}
        height={item.height}
        width={item.width}
      />
    </PhotoItemWrapper>
  );
}

export default memo(PhotoItem);
